import PropTypes from 'prop-types'
import React from 'react'
import { useFormikContext } from 'formik'
import { PhoneInputWithSelectDial } from 'SRC/ui/FormElementsNew'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import config from 'SRC/config/config.json'

import { getCountries } from 'SRC/modules/geoObjects/countries/selectors'

const Phone = ({ countries }) => {
  const formik = useFormikContext()
  const { t } = useTranslation('common')

  if (!formik || !formik.values) return null

  const prepareCountries = () => Array.isArray(countries)
    ? countries.filter(country => !country.parent).map(country => {
        const isGrouped = Boolean(countries.filter(item => item.parent === country.id).length)
        return {
          id: `${country.id}`,
          label: country.label,
          value: `${country.id}`,
          dial: `${country.dial}`,
          isGrouped,
          options: isGrouped ? countries.filter(item => item.parent === country.id).map(childCountry => ({
            id: `${childCountry.id}`,
            value: `${childCountry.id}`,
            label: childCountry.label,
            dial: `${childCountry.dial}`
          })) : null
        }
      }
    ) : []

  return (
    <PhoneInputWithSelectDial
      label={t('Broj telefona')}
      inputClass='form-group__login-phone'
      field={{ name: 'newUser.phone' }}
      form={formik}
      countries={prepareCountries()}
      wrapperClass='form-group registracija-existing-user'
      isAddAdNewUser
    />
  )
}

Phone.propTypes = {
  countries: PropTypes.array.isRequired
}

const mapStateToProps = state => ({
  countries: getCountries(state)
})

export default connect(mapStateToProps)(Phone)
